import React from 'react';

import styledC from 'styled-components';

import { useLocale } from '@adsk/alloy-react-locale';
import theme, { StylableComponent } from '@adsk/alloy-react-theme';

type SelectedCountProps = StylableComponent<HTMLDivElement> & {
  count: number;
};

const StyledDiv = styledC.div`
  ${theme.typography.labelSmall}
  display: flex;
  align-items: center;
  color: ${theme.tokens.colors.text.secondary.value};
`;

const SelectedCount = ({ count, style, ...props }: SelectedCountProps) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <StyledDiv css={style} {...props}>
      {T.translate('SELECTED', {
        count,
      })}
    </StyledDiv>
  );
};

export default SelectedCount;
